<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryTransportApplicationResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" with-custom-row-actions-first-column
                                      withCustomRowActions>
                                <template slot="left-header">
                                    <em-button type="search"
                                               v-if="pathType === 'todo'"
                                               :busy="emWorkflowListLoading"
                                               :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                                               :customLabel="isClaim ? '认领' : '待办'"
                                               show-name
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="switchClaim">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-file-export"
                                               v-if="pathType === 'list'"
                                               :disabled="actionDisabled('select')"
                                               :showName="true"
                                               custom-label="生成运输报表"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="generateTransportApplication()"
                                    >
                                    </em-button>
                                    <em-button :disabled="actionDisabled('select')"
                                               :showName="true"
                                               custom-label="更改WBS/Cost Center"
                                               type="search"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="updateWbsOrCostCenterVisible = true"
                                    >
                                    </em-button>
                                    <em-button type="task"
                                               v-if="isClaim"
                                               :disabled="$_notChecked"
                                               :busy="claimLoading"
                                               class="btn btn-outline-primary btn-sm"
                                               custom-label="认领"
                                               @click="doClaimBatch()">
                                    </em-button>
                                    <workflow-task-multiple-btn v-else-if="pathType === 'todo'"
                                                                :rows="checkedRows"
                                                                :config="config"
                                                                accept-status="task5"
                                                                :disable="isClaim"
                                                                :entity-name="modelName"
                                                                @finish="$refs.emListFilter.doQuery()">
                                    </workflow-task-multiple-btn>
                                </template>

                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <em-button type="task"
                                               :busy="claimLoading"
                                               :custom-label="isClaim ? '认领' : '处理'"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="handleExecute(customRowScope.row)">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateWbsOrCostCenterVisible"
                   title="更改WBS/Cost Center"
                   width="30%"
                   @close='clearUpdateWbsOrCostCenter'>
            <el-form ref="updateWbsOrCostCenterForm" :model="updateForm" :rules="updateWbsOrCostCenterRule"
                     label-width="auto">
                <el-form-item label="成本计入（WBS/Cost Center）" prop="wbs">
                    <el-input v-model="updateForm.wbs" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateWbsOrCostCenterVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateWbsOrCostCenter()">确认</el-button>
            </div>
        </el-dialog>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Lin
// Date 2021-08-16 17:52:43
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EmCommonApi from "@/mixin/em/common/api";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import WorkflowTaskMultipleBtn from "@/components/workflow/WorkflowTaskMultipleBtn.vue";
import inventoryTransportApplicationProcessMixin
    from "@/views/sithMes/inventory/inventoryTransportApplicationProcessMixin";
import claimTaskMixins from "@/components/workflow/mixin/ClaimTaskMixins";

export default {
    name: "sithMesInventoryTransportApplicationWorkflowListView",
    components: {WorkflowTaskMultipleBtn},
    mixins: [emWorkflowListMixin, emCommonGotoMixin, EmCommonApi, emTableCheckedMixin,
        inventoryTransportApplicationProcessMixin, claimTaskMixins],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
    },
    data() {
        return {
            updateWbsOrCostCenterVisible: false,
            updateForm: {
                wbs: ''
            },
            updateWbsOrCostCenterRule: {wbs: [{required: true, message: '请输入WBS/Cost Center'}]},
        }
    },
    methods: {
        generateTransportApplication() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/generateTransportApplication?applicationIds=${this.selectIds}`;
            this.$_emApiMixin_post(url, {})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "正在生成运输报表",
                            type: "success",
                        });
                    } else {
                        self.$message({
                            message: "生成运输报表失败",
                            type: "error",
                        });
                    }
                })
        },
        clearUpdateWbsOrCostCenter() {
            this.updateForm.wbs = ''
        },
        updateWbsOrCostCenter() {
            let self = this;
            self.$refs["updateWbsOrCostCenterForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/updateWbsOrCostCenter?ids=${this.selectIds}&wbs=${self.updateForm.wbs}`
                    self.$_emApiMixin_post(url, {})
                        .then(response => {
                            if (response.status === 200) {
                                self.$message({
                                    message: "更改WBS/Cost Center成功",
                                    type: "success",
                                });

                                self.$refs.emListFilter.doQuery();
                            } else {
                                self.$message({
                                    message: "更改WBS/Cost Center失败",
                                    type: "error",
                                });
                            }
                        })
                        .finally(() => this.updateWbsOrCostCenterVisible = false)
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            })
        },
    },
    mounted() {
        if (this.$route.query.toClaim) {
            this.isClaim = true;
        }
        if (this.$route.query.hasOwnProperty('processId')) {
            this.$nextTick(() => {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.processId);
                this.$refs.emListFilter.doQuery();
            })
        }
    },
};
</script>
